import React, { Component } from 'react'
import styled from 'styled-components'
import Loading from 'components/Loading'

class PostalInput extends Component {
  state = {
    ext: '',
    code: '',
    focus: '',
  }

  changeCode = (code) => {
    this.setState({ code }, () => {
      this.props.changeCode && this.props.changeCode(code)
    })
  }

  changeExt = (ext) => {
    this.setState({ ext }, () => {
      this.props.changeCode && this.props.changeExt(ext)
    })
  }

  search = () => {
    this.props.onClick && this.props.onClick(this.state)
  }

  render() {
    const onChangeCode = (event) => {
      const re = /^[0-9\b]+$/
      if (event.target.value && !re.test(event.target.value)) {
        return false
      }

      if (event.target.value.length === 4) {
        this.secondRef && this.secondRef.focus()
      }

      this.changeCode(event.target.value)
    }

    const onChangeExt = (event) => {
      const re = /^[0-9\b]+$/
      if (event.target.value && !re.test(event.target.value)) {
        return false
      }

      if (event.target.value.length === 3) {
        this.buttonRef && this.buttonRef.focus()
      }

      if (!event.target.value.length) {
        this.postalRef && this.postalRef.focus()
      }

      this.changeExt(event.target.value)
    }

    return (
      <Container>
        <Label>Código postal</Label>
        <InputContainer>
          <Input
            innerRef={(ref) => {
              this.postalRef = ref
            }}
            type='text'
            style={{ maxWidth: '64px' }}
            value={this.props.code}
            onChange={(e) => onChangeCode(e)}
            maxLength={4}
            autoComplete={'off'}
          />
          <Input
            type='text'
            innerRef={(ref) => {
              this.secondRef = ref
            }}
            style={{ maxWidth: '55px' }}
            value={this.props.ext}
            onChange={(e) => onChangeExt(e)}
            maxLength={3}
            autoComplete={'off'}
          />
          <Button
            innerRef={(ref) => {
              this.buttonRef = ref
            }}
            onClick={this.search}>
            {this.props.loading && <Loading size={`small`} />}
            {!this.props.loading && `Pesquisar morada`}
          </Button>
        </InputContainer>
      </Container>
    )
  }
}

const Container = styled.div`
  display: inline-block;
  width: 100%;
`

const Label = styled.span`
  display: block;
  text-align: left;
  color: #676767;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
`
const InputContainer = styled.div`
  margin-top: 8px;
  display: flex;
`

const Input = styled.input`
  border: 1px solid #dedede;
  background-color: #ffffff;
  padding: 13px 12px;
  box-sizing: border-box;
  height: 40px;
  color: #3e3e3e;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  margin-right: 8px;
  outline: none;

  &:focus {
    border-color: #93c13e;
  }
`

const Button = styled.button`
  background-color: #676767;
  border: none;
  height: 40px;
  color: #ffffff;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  padding: 0 16px;
  cursor: pointer;
`

export default PostalInput



// WEBPACK FOOTER //
// ./src/components/PostalInput/index.js